// Dados legais da empresa por tras do SAAS.GL, usados nas paginas de
// Politica de Privacidade, Termos de Uso e Politica de Cookies.
// Unica fonte de verdade -- se algum dado mudar (endereco, contato, CNPJ),
// atualizar so aqui.
export const EMPRESA = {
  nomeFantasia: "SAAS.GL",
  razaoSocial: "64.978.464 ABIMAEL DOS SANTOS MELO",
  cnpj: "64.978.464/0001-50",
  cidade: "São Bernardo do Campo",
  uf: "SP",
  contatoEmail: "asaasleamiba@gmail.com",
};
